class UgcVideoSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('[data-slider]');
    if (!this.slider) return;

    this.#initSlider();
    this.#bindEvents();
  }

  disconnectedCallback() {
    this.#destroySlider();
  }

  #initSlider() {
    const Flickity = window.theme?.Flickity;
    if (!Flickity || !this.slider) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    this.flkty = new Flickity(this.slider, {
      cellAlign: isMobile ? 'center' : 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: !isMobile,
      groupCells: !isMobile,
      freeScroll: false,
      wrapAround: false,
      cellSelector: '[data-slide]',
      arrowShape: window.theme?.defined?.arrowShape || 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
    });
  }

  #destroySlider() {
    if (this.flkty) {
      this.flkty.destroy();
      this.flkty = null;
    }
  }

  #bindEvents() {
    this.addEventListener('click', this.#handleClick.bind(this));
  }

  #handleClick(event) {
    const item = event.target.closest('.ugc-video-slider__item');
    if (!item) return;

    const video = item.querySelector('.ugc-video-slider__video');
    if (!video) return;

    if (item.classList.contains('is-playing')) {
      this.#pauseVideo(item, video);
    } else if (item.classList.contains('is-paused')) {
      this.#resumeVideo(item, video);
    } else {
      this.#stopAllVideos();
      this.#playVideo(item, video);
    }
  }

  #playVideo(item, video) {
    item.classList.add('is-playing');
    video.muted = false;
    video.play();

    video.addEventListener('ended', () => {
      this.#resetVideo(item, video);
    }, { once: true });
  }

  #pauseVideo(item, video) {
    item.classList.remove('is-playing');
    item.classList.add('is-paused');
    video.pause();
  }

  #resumeVideo(item, video) {
    item.classList.remove('is-paused');
    item.classList.add('is-playing');
    video.play();
  }

  #resetVideo(item, video) {
    item.classList.remove('is-playing', 'is-paused');
    video.pause();
    video.currentTime = 0;
    video.muted = true;
  }

  #stopAllVideos() {
    for (const item of this.querySelectorAll('.ugc-video-slider__item.is-playing, .ugc-video-slider__item.is-paused')) {
      const video = item.querySelector('.ugc-video-slider__video');
      if (video) this.#resetVideo(item, video);
    }
  }
}

customElements.define('ugc-video-slider', UgcVideoSlider);
